<snelstart-ui-dialog-definition [(visible)]="this.dialogVisible"
                                [useTitleBorder]="false"
                                id="ki"
                                size="xl"
                                title="Klantinstellingen">


    <snelstart-ui-dialog-body [padding]="0">
        <snelstart-ui-tab>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(0)"
                    [isActive]="this.selectedTab === 0"
                    id="firstTab"
            >
                Algemeen
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(1)"
                    [isActive]="this.selectedTab === 1"
                    id="secondTab"
            >
                Contact
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(2)"
                    [isActive]="this.selectedTab === 2"
                    id="thirdTab"
            >
                SnelStart administraties
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(3)"
                    [isActive]="this.selectedTab === 3"
                    id="sixthTab"
            >
                Externe administraties
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(4)"
                    [isActive]="this.selectedTab === 4"
                    id="forthTab"
            >
                Belastingplicht
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(5)"
                    [isActive]="this.selectedTab === 5"
                    id="forthTab"
            >
                Jaarrapportage
            </snelstart-ui-tab-item>
            <snelstart-ui-tab-item
                    (click)="onSelectTab(6)"
                    [isActive]="this.selectedTab === 6"
                    id="fifthTab"
            >
                Uitstel
            </snelstart-ui-tab-item>

        </snelstart-ui-tab>
        <snelstart-ui-tab-content>
            @if (selectedTab === 0) {
                <div [formGroup]="customerFg">
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    [required]=true
                                                    class="custom-input-250"
                                                    formControlName="name"
                                                    id="name"
                                                    label="Naam*"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    class="custom-input-250"
                                                    formControlName="kvk"
                                                    id="kvk"
                                                    label="KVK-nummer*"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-bsn-form-control [disabledControl]=true
                                                   class="me-1 custom-input-250"
                                                   formControlName="fiscalIdentifier"
                                                   id="taxId"
                                                   label="Fiscaal nummer*"
                    >
                    </snelstart-ui-bsn-form-control>
                </div>
                <div [formGroup]="clientFg">
                    <snelstart-ui-text-form-control (change)="updateForm()"
                                                    class="custom-input-250"
                                                    formControlName="taxIdVat"
                                                    id="taxIdVat"
                                                    label="Omzetbelastingnummer"
                    >
                    </snelstart-ui-text-form-control>
                    @if (!hasValidVatNumber) {
                        <snelstart-ui-alert class="ps-1" type="warning">
                            Geen geldig omzetbelastingnummer: Vul een getal van 9 cijfers (BSN/RSIN) in, gevolgd door
                            een code variërend van B01 tot B99. Gebruik zo nodig 1 of 2 voorloopnullen, maar gebruik
                            geen 'NL' bij het omzetbelastingnummer.
                            Let op: vul bij een eenmanszaak dus niet het Btw-identificatienummer in!
                        </snelstart-ui-alert>
                    }
                </div>
                <p class="pt-3" style="font-weight: lighter">
                    * Wijzig deze gegevens door in de klantenlijst op de drie puntjes rechts in de rij te klikken en
                    kies voor 'Wijzigen'.
                </p>
            }
            @if (selectedTab === 1) {
                <div [formGroup]="customerFg">
                    <div formGroupName="address">
                        <snelstart-ui-text-form-control [disabledControl]="true"
                                                        class="custom-input-250"
                                                        formControlName="streetName"
                                                        id="streetName"
                                                        label="Straat"
                        >
                        </snelstart-ui-text-form-control>
                        <div class="row">
                            <div class="col-auto" style="padding-right: 4px">
                                <snelstart-ui-text-form-control [disabledControl]="true"
                                                                class="custom-input-60"
                                                                formControlName="streetNumber"
                                                                id="streetNumber"
                                                                label="Huisnr."
                                >
                                </snelstart-ui-text-form-control>
                            </div>
                            <div class="col-auto">
                                <snelstart-ui-text-form-control [disabledControl]="true"
                                                                class="custom-input-50"
                                                                formControlName="affix"
                                                                id="affix"
                                                                label="Toev."
                                >
                                </snelstart-ui-text-form-control>
                            </div>
                            <div class="col-auto">
                                <snelstart-ui-text-form-control [disabledControl]="true"
                                                                class="custom-input-100"
                                                                formControlName="postalCode"
                                                                id="postalCode"
                                                                label="Postcode"
                                >
                                </snelstart-ui-text-form-control>
                            </div>
                        </div>
                        <snelstart-ui-text-form-control [disabledControl]="true"
                                                        class="custom-input-250"
                                                        formControlName="city"
                                                        id="city"
                                                        label="Plaats"
                        >
                        </snelstart-ui-text-form-control>
                    </div>
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    class="custom-input-250"
                                                    formControlName="phoneNumber"
                                                    id="phoneNumber"
                                                    label="Telefoonnummer vast"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control [disabledControl]="true"
                                                    class="custom-input-250"
                                                    formControlName="mobileNumber"
                                                    id="mobileNumber"
                                                    label="Telefoonnummer mobiel"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-email-form-control [disabledControl]="true"
                                                     class="custom-input-250"
                                                     formControlName="emailAddressLine"
                                                     id="emailAddressLine"
                                                     label="E-mailadres"
                    >
                    </snelstart-ui-email-form-control>
                </div>

                <p class="pt-3" style="font-weight: lighter">
                    Wijzig deze gegevens in SnelStart Relaties (Polaris).
                </p>

            }
            @if (selectedTab === 2) {
                <div [formGroup]="adminListFg">
                    <div formArrayName="administraties">
                        @for (item of administraties.controls; track $index) {
                            <div [formGroupName]="$index">
                                @if (item.getRawValue().id !== null) {
                                    <div class="row mb-1">
                                        <div class="col-auto">
                                            <snelstart-ui-text-form-control
                                                    [disabledControl]="true"
                                                    [label]="$index === 0 ? 'SnelStart administraties' : ''"
                                                    class="custom-input-250"
                                                    formControlName="name"
                                                    id="name"
                                            >
                                            </snelstart-ui-text-form-control>
                                        </div>
                                        <div class="col-auto">
                                            <snelstart-ui-button
                                                    (click)="verwijderRij($index)"
                                                    [class]="$index === 0 ? 'pt-3' : ''"
                                                    icon="trash"
                                                    iconType="light"
                                                    id="buttonDelete"
                                                    size="medium"
                                                    type="secondary"
                                            >
                                            </snelstart-ui-button>
                                        </div>
                                    </div>
                                } @else {
                                    <div class="row align-center">
                                        <snelstart-ui-select-form-control (change)="this.saveForm($index)"
                                                                          [label]="$index === 0 ? 'SnelStart administratie' : ''"
                                                                          [options]="this.administrationList"
                                                                          class="col-auto custom-input-250"
                                                                          formControlName="administrationId"
                                                                          id="administrationId"
                                        >
                                        </snelstart-ui-select-form-control>
                                        <snelstart-ui-button
                                                (click)="verwijderRij($index)"
                                                [class]="$index === 0 ? 'pt-3' : ''"
                                                class="col-auto"
                                                icon="trash"
                                                iconType="light"
                                                id="buttonDelete"
                                                size="medium"
                                                type="secondary"
                                        >
                                        </snelstart-ui-button>
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    @if (this.administraties.length === 0) {
                        <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="addA"
                                             type="secondary">SnelStart administratie koppelen
                        </snelstart-ui-button>
                    } @else {
                        <snelstart-ui-button (click)="addRij()" [disabled]="allAdministrationsDisabled()"
                                             class="snelstart-ui-button pb-3" icon="plus"
                                             id="addB"
                                             type="secondary">Nog een administratie toevoegen
                        </snelstart-ui-button>
                    }
                </div>
            }
            @if (selectedTab === 3) {
                <div [formGroup]="balanceBaseFg">
                    @if (this.externGekoppeld()) {
                        <snelstart-ui-alert type="info">
                            Per client kan er 1 externe administratie worden gekoppeld. Er is al een externe
                            administratie gekoppeld, waardoor het koppelen van een administratie nu niet mogelijk is. Om
                            een nieuwe administratie te koppelen, dient de bestaande koppeling te worden verwijderd. Dit
                            kan onder het tabblad 'SnelStart Administraties'.
                        </snelstart-ui-alert>
                    } @else {
                        <snelstart-ui-select-form-control (change)="checkLoginStatus()"
                                                          [options]="this.optionsProviders"
                                                          class="custom-input-250"
                                                          formControlName="provider"
                                                          id="provider"
                                                          label="Selecteer extern boekhoudpakket"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-button (click)="this.goToExternalProvider()"
                                             *ngIf="balanceBaseFg.get('provider')?.getRawValue() !== null"
                                             class="me-1 custom-input-250 pt-3"
                                             icon="arrow-up-right-from-square"
                                             type="secondary"
                        >
                            Inloggen bij {{ balanceBaseFg.get('provider')?.value }}
                        </snelstart-ui-button>
                        @if (this.loginStatus && this.hasEnvironments) {
                            <snelstart-ui-select-form-control (change)="this.saveEnvironmentBalanceProvider()"
                                                              [options]="this.optionsExterneEnvironments"
                                                              class="custom-input-250"
                                                              formControlName="environment"
                                                              id="environment"
                                                              label="Selecteer omgeving: {{ balanceBaseFg.get('provider')?.value }}"
                                                              placeholder="-- Selecteer omgeving --"
                            >
                            </snelstart-ui-select-form-control>
                        }
                        @if (this.loginStatus && this.administrationsLoaded && this.hasEnvironmentsSelected) {
                            <snelstart-ui-select-form-control (change)="this.saveAdministratieBalanceProvider()"
                                                              [options]="this.optionsExterneAdministraties"
                                                              class="custom-input-250"
                                                              formControlName="administratie"
                                                              id="administratie"
                                                              label="Selecteer administratie: {{ balanceBaseFg.get('provider')?.value }}"
                                                              placeholder="-- Selecteer administratie --"
                            >
                            </snelstart-ui-select-form-control>
                        }
                    }
                </div>
            }
            @if (selectedTab === 4) {
                <div [formGroup]="clientFg">
                    @if (this.clientFg.get('corporateTax')?.getRawValue() === false) {
                        <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                          [options]="optionsJaNee"
                                                          [required]=true
                                                          class="custom-input-250"
                                                          formControlName="incomeTax"
                                                          id="incomeTax"
                                                          label="Belastingplicht inkomstenbelasting"
                        >
                        </snelstart-ui-select-form-control>
                        @if (this.heeftBVInNaamMetInkomstenbelasting()) {
                            <div style="width: 75%; color: red" class="pb-2">

                                    Let op: de naam van deze klant bevat 'BV'. Een BV is een rechtspersoon en is
                                    doorgaans
                                    niet belastingplichtig voor de inkomstenbelasting. Controleer of de belastingplicht
                                    correct is ingesteld.

                            </div>
                        }
                    }

                    @if (this.clientFg.get('incomeTax')?.getRawValue() === false) {
                        <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                          [options]="optionsJaNee"
                                                          [required]=true
                                                          class="custom-input-250"
                                                          formControlName="corporateTax"
                                                          id="corporateTax"
                                                          label="Belastingplicht vennootschapsbelasting"
                        >
                        </snelstart-ui-select-form-control>
                    }
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      [required]=true
                                                      class="custom-input-250"
                                                      formControlName="valueAddedTax"
                                                      id="valueAddedTax"
                                                      label="Belastingplicht omzetbelasting"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                      [options]="optionsJaNeeLb"
                                                      [required]=true
                                                      class="custom-input-250"
                                                      formControlName="wageTax"
                                                      id="wageTax"
                                                      label="Inhoudingsplicht loonbelasting"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-text-form-control (focusout)="this.clientFg.get('taxIdWageTax')?.markAsTouched()"
                                                    (input)="normalizeLoonheffingennummer()"
                                                    *ngIf="this.clientFg.get('wageTax')?.getRawValue() === true"
                                                    [required]=true
                                                    class="custom-input-250"
                                                    formControlName="taxIdWageTax"
                                                    id="taxIdWageTax"
                                                    label="Loonheffingennummer"
                    >
                    </snelstart-ui-text-form-control>

                    @if (this.clientFg.get('taxIdWageTax')?.touched && this.clientFg.get('taxIdWageTax')?.hasError('required')) {
                        <div class="text-danger ms-2">
                            Loonheffingennummer is verplicht.
                        </div>
                    }

                    @if (this.clientFg.get('wageTax')?.getRawValue() === true
                    && this.clientFg.get('taxIdWageTax')?.touched
                    && this.hasInvalidLoonheffingennummer()) {
                        <div class="text-danger ms-2">
                            Ongeldig formaat. Gebruik: 123456789L01
                        </div>
                    }
                </div>
            }
            @if (selectedTab === 5) {
                <div [formGroup]="clientFg">
                    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                      [options]="optionsSbiCode"
                                                      class="custom-input-250"
                                                      formControlName="sbiCode"
                                                      id="sbiCode"
                                                      label="SBI-code"
                    >
                    </snelstart-ui-select-form-control>
                    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                      [options]="optionsBedrijfsklasse"
                                                      class="custom-input-250"
                                                      formControlName="classificatie"
                                                      id="classificatie"
                                                      label="Bedrijfsklasse"
                    >
                    </snelstart-ui-select-form-control>
                </div>
            }
            @if (selectedTab === 6) {
                @if (this.hasValidIntermediaryData()) {
                    <div style="width: 75%">
                        <snelstart-ui-alert type="info">
                            Geef onderstaand aan of deze klant opgenomen moet worden in de uitstel (beconregeling).
                            <br/>
                            De lijst met uitstelverzoeken en voortgang, alsmede het afmelden van klanten voor de
                            uitstelregeling, vind je op de pagina 'Uitstelregeling'.
                        </snelstart-ui-alert>
                    </div>
                    <div [formGroup]="clientFg">
                        <snelstart-ui-select-form-control (change)="this.saveForm()"
                                                          [options]="optionsJaNee"
                                                          [required]=true
                                                          class="custom-input-250"
                                                          formControlName="postponement"
                                                          id="postponement"
                                                          label="Opnemen in uitstel (beconregeling)"
                        >
                        </snelstart-ui-select-form-control>
                    </div>
                } @else {
                    <div style="width: 75%">
                        <snelstart-ui-alert type="info">
                            De kantoorgegevens van je kantoororganisatie zijn nog niet volledig ingevuld. <br/>
                            Voor het toepassen van de Beconregeling zijn een beconnummer, een RSIN en een
                            PKI-certificaat nodig.
                        </snelstart-ui-alert>
                    </div>
                }
            }
        </snelstart-ui-tab-content>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button (click)="this.dialogVisibleChange.emit(false)" btn-x class="me-1" id="cancel"
                             type="secondary"
        >Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button (click)="saveClient()"
                             [disabled]="!hasValidVatNumber || hasInvalidLoonheffingennummer()"
                             icon="check"
                             id="save"
                             ignoreClick
                             type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>




